<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner-list">
    <div class="row mb-4">
      <div class="col-md-6">
        <div class="title-wrapper">
          <div>
            <h1 class="title-default">Lista de Pessoas</h1>
            <p class="welcome-message">Gerenciamento de Pessoas</p>
          </div>
        </div>
      </div>
      <div class="col-md-6 header-actions">
        <button mat-stroked-button class="btn-secondary" [matMenuTriggerFor]="opcoesMenu">
          @if (selection.hasValue()) {
          <span>Ações ({{ selection.selected.length }})</span>
          } @else {
          <span>Ações</span>
          }
          <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
        </button>

        <mat-menu #opcoesMenu="matMenu">
          @if (selection.hasValue()) {
          <button mat-menu-item (click)="alterarStatusEmMassa()">
            <mat-icon class="material-symbols-outlined">sync_alt</mat-icon>
            <span>Alterar status em massa</span>
          </button>
          <button mat-menu-item (click)="vincularVendedorEmMassa()">
            <mat-icon class="material-symbols-outlined">person_add</mat-icon>
            <span>Vincular vendedor</span>
          </button>
          <button mat-menu-item (click)="abrirModalExcluir()">
            <mat-icon class="material-symbols-outlined">delete</mat-icon>
            <span>Excluir selecionados</span>
          </button>
          } @else {
          <button mat-menu-item (click)="imprimir()">
            <mat-icon class="material-symbols-outlined">print</mat-icon>
            <span>Imprimir</span>
          </button>
          <button mat-menu-item (click)="imprimirAgrupado()">
            <mat-icon class="material-symbols-outlined">print</mat-icon>
            <span>Imprimir cadastros agrupados</span>
          </button>
          <button mat-menu-item (click)="listarAniversariantes()">
            <mat-icon class="material-symbols-outlined">print</mat-icon>
            <span>Listar aniversariantes</span>
          </button>
          <button mat-menu-item (click)="fazerPedidoExtracao(_tipoExtracaoEnum.ListaPessoas, $event)">
            @if (_isLoadingDownloadAll === true) {
            <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
            } @else {
            <mat-icon class="material-symbols-outlined">file_upload</mat-icon>
            <span>Exportar Pessoas</span>
            }
          </button>
          <button mat-menu-item (click)="importar()">
            <mat-icon class="material-symbols-outlined">file_download</mat-icon>
            <span>Importar Pessoas</span>
          </button>
          }
        </mat-menu>

        <button type="button" mat-flat-button class="btn-primary" routerLink="/cadastros/pessoas/cadastrar">
          <mat-icon class="material-symbols-outlined">add</mat-icon>
          Novo Cadastro
        </button>
      </div>
    </div>

    <form [formGroup]="model" (ngSubmit)="clickPesquisar()">
      <div class="row search-area">
        <div class="col-12 col-md-6">
          <mat-form-field appearance="outline">
            <mat-label>Pesquisar</mat-label>
            <input matInput type="text" formControlName="pesquisa" placeholder="nome, email ou telefone..." />

            <button mat-icon-button matSuffix [matMenuTriggerFor]="refinarMenu" type="button" aria-label="Refinar Busca"
              matTooltip="Refinar busca">
              <mat-icon>tune</mat-icon>
            </button>
            <mat-menu #refinarMenu="matMenu">
              <button mat-menu-item (click)="filtroRefinar = null">
                @if (filtroRefinar === null) {
                <mat-icon>check</mat-icon>
                }
                <span [class.ps-4]="filtroRefinar !== null">Não refinar</span>
              </button>
              <button mat-menu-item (click)="filtroRefinar = _pessoaListaRefinamentoEnum.nome">
                @if (filtroRefinar === _pessoaListaRefinamentoEnum.nome) {
                <mat-icon>check</mat-icon>
                }
                <span [class.ps-4]="filtroRefinar !== _pessoaListaRefinamentoEnum.nome">Nome</span>
              </button>
              <button mat-menu-item (click)="filtroRefinar = _pessoaListaRefinamentoEnum.email">
                @if (filtroRefinar === _pessoaListaRefinamentoEnum.email) {
                <mat-icon>check</mat-icon>
                }
                <span [class.ps-4]="filtroRefinar !== _pessoaListaRefinamentoEnum.email">E-mail</span>
              </button>
              <button mat-menu-item (click)="filtroRefinar = _pessoaListaRefinamentoEnum.documento">
                @if (filtroRefinar === _pessoaListaRefinamentoEnum.documento) {
                <mat-icon>check</mat-icon>
                }
                <span [class.ps-4]="filtroRefinar !== _pessoaListaRefinamentoEnum.documento">Documento</span>
              </button>
              <button mat-menu-item (click)="filtroRefinar = _pessoaListaRefinamentoEnum.telefone">
                @if (filtroRefinar === _pessoaListaRefinamentoEnum.telefone) {
                <mat-icon>check</mat-icon>
                }
                <span [class.ps-4]="filtroRefinar !== _pessoaListaRefinamentoEnum.telefone">Telefone</span>
              </button>
            </mat-menu>

            <button mat-icon-button matSuffix type="submit" aria-label="Pesquisar">
              <mat-icon>search</mat-icon>
            </button>
          </mat-form-field>
        </div>
        <div class="col-12 col-md-6">
          <button mat-stroked-button type="button" class="btn-filter margin-right-15" [matMenuTriggerFor]="filtroMenu"
            [matBadge]="qtdFiltrosAvancados" [matBadgeHidden]="qtdFiltrosAvancados === 0">
            <mat-icon>filter_list</mat-icon>
            Filtrar
          </button>
          <mat-menu #filtroMenu="matMenu" class="filter-custom-menu">
            <div class="filter-menu-content" [formGroup]="model">
              <div (click)="$event.stopPropagation()">
                <h6>Filtros Avançados</h6>

                <div class="filter-menu__form">
                  <!-- Vendedor -->
                  <app-select-pesquisavel
                    label="Vendedor"
                    [control]="$any(model.get('idVendedor'))"
                    [idField]="'id'"
                    [nameField]="'descricao'"
                    [apiUrl]="urlVendedor"
                    [isOptional]="true"
                    hint="Qualquer vendedor"
                    (selectionChange)="changeVendedor($event)">
                  </app-select-pesquisavel>

                  <!-- UF -->
                  <app-select-pesquisavel
                    label="UF"
                    [control]="$any(model.get('idUf'))"
                    [idField]="'id'"
                    [nameField]="'descricao'"
                    [offlineList]="listaUf"
                    [isOptional]="true"
                    hint="Qualquer UF"
                    (selectionChange)="changeUf($event)">
                  </app-select-pesquisavel>

                  <!-- Municipio -->
                  <app-select-pesquisavel
                    label="Município"
                    [control]="$any(model.get('idMunicipio'))"
                    (selectionChange)="changeCidade($event)"
                    [idField]="'idMunicipio'"
                    [nameField]="'nome'"
                    [apiUrl]="urlMunicipio"
                    [isOptional]="true"
                    hint="Qualquer município">
                  </app-select-pesquisavel>

                  <!-- Tipo de Contato -->
                  <app-select-pesquisavel label="Tipo de Contato" [control]="$any(model.get('idTipoContato'))"
                    [idField]="'id'" [nameField]="'descricao'" [offlineList]="listaTipoContato" [isOptional]="true"
                    hint="Qualquer tipo de contato">
                  </app-select-pesquisavel>
                </div>
              </div>

              <div class="filter-menu__actions">
                <button mat-button class="btn-secondary" matMenuClose>Cancelar</button>
                <button mat-flat-button class="btn-primary" (click)="aplicarFiltros()" matMenuClose>
                  Aplicar
                </button>
              </div>
            </div>
          </mat-menu>

          <button mat-stroked-button type="button" class="btn-filter" (click)="limparFiltros()">
            <mat-icon>cleaning_services</mat-icon>
            Limpar Filtros
          </button>
        </div>
      </div>
    </form>

    @if (_listaPessoaResponse && _dataSource.data.length > 0) {
    <table mat-table class="desktop-view" [dataSource]="_dataSource" matSort>
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef class="w-checkbox">
          <mat-checkbox (change)="$event ? toggleAllRows() : null" [checked]="selection.hasValue() && isAllSelected()"
            [aria-label]="checkboxLabel()">
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row" class="w-checkbox">
          <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
            [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
          </mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="nome">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Nome</th>
        <td mat-cell *matCellDef="let element">
          {{ element.nome }}
        </td>
      </ng-container>

      <ng-container matColumnDef="documento">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Documento</th>
        <td mat-cell *matCellDef="let element">
          {{
          element.cpfFormatado
          ? element.cpfFormatado
          : element.cnpjFormatado
          ? element.cnpjFormatado
          : element.documentoEstrangeiro
          }}
        </td>
      </ng-container>

      <ng-container matColumnDef="contato">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Contato</th>
        <td mat-cell *matCellDef="let element">
          <div class="coluna-contatos">
            @if (element.emailNFe) {
            <span><mat-icon class="material-symbols-outlined contact_icon">email</mat-icon>
              {{ element.emailNFe }}</span>
            }
            @if (element.telefoneFormatado) {
            <span><mat-icon class="material-symbols-outlined contact_icon">phone</mat-icon>
              {{ element.telefoneFormatado }}</span>
            }
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="tipo_contato">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Tipo de Contato</th>
        <td mat-cell *matCellDef="let element">
          {{ getTipoContatoLabel(element) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
        <td mat-cell *matCellDef="let element">
          <span class="status-badge" [ngClass]="getStatusClass(element.isAtivo)">
            {{ getStatusLabel(element.isAtivo) }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef class="text-center w-actions">Ações</th>
        <td mat-cell *matCellDef="let element" class="text-center w-actions">
          <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Ações">
            <span class="material-symbols-outlined">more_horiz</span>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item [routerLink]="['/cadastros/pessoas/cadastrar', { idPessoa: element.idPessoa }]">
              <span class="material-symbols-outlined">edit</span>
              <span>Editar</span>
            </button>
            <button mat-menu-item (click)="abrirModalExcluir(element)">
              <span class="material-symbols-outlined">delete</span>
              <span>Excluir</span>
            </button>
            <mat-divider></mat-divider>
            @let motivoCrm = getMotivoCrmIndisponivel(element.listIdTipoContato);
            <span [matTooltip]="motivoCrm" matTooltipPosition="left">
              <button mat-menu-item [disabled]="!!motivoCrm" [attr.aria-label]="motivoCrm || null" (click)="abrirOportunidadesCrm(element)">
                <span class="material-symbols-outlined">forum</span>
                <span>Ver oportunidades no CRM</span>
              </button>
            </span>
            <span [matTooltip]="motivoCrm" matTooltipPosition="left">
              <button mat-menu-item [disabled]="!!motivoCrm" [attr.aria-label]="motivoCrm || null"
                (click)="incluirOportunidadeCrm(element)">
                <span class="material-symbols-outlined">add_comment</span>
                <span>Incluir oportunidade no CRM</span>
              </button>
            </span>
            <mat-divider></mat-divider>
            @let motivoOrcamentoPedido = getMotivoOrcamentoPedidoIndisponivel(element.listIdTipoContato);
            @let motivoNotaFiscal = getMotivoNotaFiscalIndisponivel(element.listIdTipoContato);
            <span [matTooltip]="motivoOrcamentoPedido" matTooltipPosition="left">
              <button mat-menu-item [disabled]="!!motivoOrcamentoPedido" [attr.aria-label]="motivoOrcamentoPedido || null"
                (click)="incluirOrcamento(element)">
                <span class="material-symbols-outlined">request_quote</span>
                <span>Incluir orçamento</span>
              </button>
            </span>
            <span [matTooltip]="motivoOrcamentoPedido" matTooltipPosition="left">
              <button mat-menu-item [disabled]="!!motivoOrcamentoPedido" [attr.aria-label]="motivoOrcamentoPedido || null"
                (click)="criarPedidoVenda(element)">
                <span class="material-symbols-outlined">shopping_cart</span>
                <span>Criar pedido de venda</span>
              </button>
            </span>
            <span [matTooltip]="motivoNotaFiscal" matTooltipPosition="left">
              <button mat-menu-item [disabled]="!!motivoNotaFiscal" [attr.aria-label]="motivoNotaFiscal || null"
                (click)="criarNotaFiscal(element)">
                <span class="material-symbols-outlined">receipt_long</span>
                <span>Criar nota fiscal</span>
              </button>
            </span>
            <mat-divider></mat-divider>
            <button mat-menu-item (click)="abrirUltimasVendas(element)">
              <span class="material-symbols-outlined">point_of_sale</span>
              <span>Consultar últimas vendas</span>
            </button>
            <button mat-menu-item (click)="abrirUltimasCompras(element)">
              <span class="material-symbols-outlined">local_shipping</span>
              <span>Consultar últimas compras</span>
            </button>
            <span matTooltip="Em definição" matTooltipPosition="left">
              <button mat-menu-item disabled aria-label="Em definição">
                <span class="material-symbols-outlined">home_repair_service</span>
                <span>Consultar últimos serviços</span>
              </button>
            </span>
          </mat-menu>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <div class="mobile-view">
      @for (pessoa of _dataSource.data; track pessoa.idPessoa) {
      <div class="card-mobile mb-3" [class.selected-card]="selection.isSelected(pessoa)">
        <div class="card-header-mobile d-flex justify-content-between align-items-center">
          <div class="d-flex align-items-center gap-2">
            <mat-checkbox (change)="$event ? selection.toggle(pessoa) : null" [checked]="selection.isSelected(pessoa)"
              color="primary">
            </mat-checkbox>
            <span class="text-bold">{{ pessoa.nome }}</span>
          </div>
          <button mat-icon-button [matMenuTriggerFor]="menuMobile">
            <span class="material-symbols-outlined">more_horiz</span>
          </button>
          <mat-menu #menuMobile="matMenu">
            <button mat-menu-item [routerLink]="['/cadastros/pessoas/cadastrar', { idPessoa: pessoa.idPessoa }]">
              Editar
            </button>
            <button mat-menu-item (click)="abrirModalExcluir(pessoa)">Excluir</button>
            <mat-divider></mat-divider>
            @let motivoCrmMobile = getMotivoCrmIndisponivel(pessoa.listIdTipoContato);
            <span [matTooltip]="motivoCrmMobile" matTooltipPosition="left">
              <button mat-menu-item [disabled]="!!motivoCrmMobile" [attr.aria-label]="motivoCrmMobile || null"
                (click)="abrirOportunidadesCrm(pessoa)">
                Ver oportunidades no CRM
              </button>
            </span>
            <span [matTooltip]="motivoCrmMobile" matTooltipPosition="left">
              <button mat-menu-item [disabled]="!!motivoCrmMobile" [attr.aria-label]="motivoCrmMobile || null"
                (click)="incluirOportunidadeCrm(pessoa)">
                Incluir oportunidade no CRM
              </button>
            </span>
            <mat-divider></mat-divider>
            @let motivoOrcamentoPedidoMobile = getMotivoOrcamentoPedidoIndisponivel(pessoa.listIdTipoContato);
            @let motivoNotaFiscalMobile = getMotivoNotaFiscalIndisponivel(pessoa.listIdTipoContato);
            <span [matTooltip]="motivoOrcamentoPedidoMobile" matTooltipPosition="left">
              <button mat-menu-item [disabled]="!!motivoOrcamentoPedidoMobile"
                [attr.aria-label]="motivoOrcamentoPedidoMobile || null" (click)="incluirOrcamento(pessoa)">
                Incluir orçamento
              </button>
            </span>
            <span [matTooltip]="motivoOrcamentoPedidoMobile" matTooltipPosition="left">
              <button mat-menu-item [disabled]="!!motivoOrcamentoPedidoMobile"
                [attr.aria-label]="motivoOrcamentoPedidoMobile || null" (click)="criarPedidoVenda(pessoa)">
                Criar pedido de venda
              </button>
            </span>
            <span [matTooltip]="motivoNotaFiscalMobile" matTooltipPosition="left">
              <button mat-menu-item [disabled]="!!motivoNotaFiscalMobile" [attr.aria-label]="motivoNotaFiscalMobile || null"
                (click)="criarNotaFiscal(pessoa)">
                Criar nota fiscal
              </button>
            </span>
            <mat-divider></mat-divider>
            <button mat-menu-item (click)="abrirUltimasVendas(pessoa)">Consultar últimas vendas</button>
            <button mat-menu-item (click)="abrirUltimasCompras(pessoa)">Consultar últimas compras</button>
            <span matTooltip="Em definição" matTooltipPosition="left">
              <button mat-menu-item disabled aria-label="Em definição">Consultar últimos serviços</button>
            </span>
          </mat-menu>
        </div>
        <div class="card-body-mobile p-3">
          <p class="mb-1">
            <strong>Documento:</strong>
            {{
            pessoa.cpfFormatado
            ? pessoa.cpfFormatado
            : pessoa.cnpjFormatado
            ? pessoa.cnpjFormatado
            : pessoa.documentoEstrangeiro
            }}
          </p>
          <p class="mb-1"><strong>Email:</strong> {{ pessoa.emailNFe }}</p>
          <p class="mb-1"><strong>Telefone:</strong> {{ pessoa.telefoneFormatado }}</p>
          <p class="mb-1"><strong>Tipo de Contato:</strong> {{ getTipoContatoLabel(pessoa) }}</p>
          <span class="status-badge" [ngClass]="getStatusClass(pessoa.isAtivo)">
            {{ getStatusLabel(pessoa.isAtivo) }}
          </span>
        </div>
      </div>
      }
    </div>

    <div class="col-12 text-center mt-4 mb-5">
      <button mat-button [disabled]="_ultimaPagina" (click)="proximaPagina()">
        @if (_isLoading === true) {
        <mat-spinner [diameter]="20"></mat-spinner>
        } @else {
        <span class="material-symbols-outlined">expand_more</span>
        Ver Mais
        }
      </button>
    </div>
    } @else if ((_isLoading === true || loadLookups === true) && _dataSource.data.length === 0) {
    <app-loading-box-default-list></app-loading-box-default-list>
    } @else {
    <app-empty-list [title]="'Nenhuma pessoa encontrada'"
      [subTitle]="'Tente alterar os filtros de busca'"></app-empty-list>
    }
  </div>
</div>